import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Paper, Input, Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import MoreMenu from './MoreMenu/moreMenu';

const Search = props => {
  const { onSearch } = props;
  const classes = useStyles();
  const [values, setValues] = React.useState({
    name: props.vlrinicial,
  });

  //------------------------------- FUNCTIONS ----------------------------------------------------//
  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
    onSearch(event.target.value);
  };

  //---------------------------------- RENDER ----------------------------------------------------//
  return (
    <Grid item xs={12} sm={12} md={8} lg={8} xl={8} className={classes.gridSearch}>
      <Paper className={classes.searchFixo} elevation={1}>
        <SearchIcon className={classes.searchIcon} />
        <Input
          className={classes.searchInput}
          disableUnderline
          placeholder="Busca"
          value={values.name}
          onChange={handleChange('name')}
        />
        {!window.ReactNativeWebView && (
          <MoreMenu
            exportToXLS={props.exportToXLS}
            exportToCSV={props.exportToCSV}
            exportToPDF={props.exportToPDF}
            showPdfExport={props.showPdfExport}
          />
        )}
      </Paper>
    </Grid>
  );
};

//----------------------------------- PROPTYPES --------------------------------------------------//
Search.propTypes = {
  className: PropTypes.string,
  vlrinicial: PropTypes.string,
  onSearch: PropTypes.func,
  exportToCSV: PropTypes.func.isRequired,
  exportToXLS: PropTypes.func.isRequired,
  exportToPDF: PropTypes.func,
  showPdfExport: PropTypes.bool,
};

//------------------------------------------------------------------------------------------------//

//-----------------------------------ESTILIZAÇÃO--------------------------------------------------//
const useStyles = makeStyles(theme => ({
  searchFixo: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon,
  },
  searchInput: {
    flexGrow: 1,
  },
  gridSearch: {
    margin: 'auto',
  },
}));

//------------------------------------------------------------------------------------------------//

export default Search;
